import {gql} from "@apollo/client";

export const GET_GAME_FIELDS = gql`
          fragment GetGameFields on Game{
                    id
                    name
                    urlName
                    rTP
                    paylines
                    releaseDate
                    volatility
                    listOrder
                    studio {
                      id
                      logoUrl
                      logoDarkBackgroundUrl
                      logoFaviconUrl
                      urlName
                      name
                    }
                    demo
                    images {
                      id
                      type
                      url
                    }
                    minStake
                    maxStake
                    themes {
                      enabledInFilters
                      id
                      codeName
                    }
                    features {
                      id
                      codeName
                      enabledInFilters
                    }
                    categories {
                      codeName
                      id
                      enabledInFilters
                    }
          }`;

export const GET_GAMES = gql`
          ${GET_GAME_FIELDS}
          query GetGames ($order:[GameSortInput!],$where:GameFilterInput,$category:String){
                games (order:$order,where: $where,category:$category){
                    ...GetGameFields
                }
              }
          `;

export const GET_GAMES_SITEMAP = gql`
          query GetGamesSiteMap ($order:[GameSortInput!],$where:GameFilterInput,$category:String){
                games (order:$order,where: $where,category:$category){
                    urlName
                    studio {
                        urlName
                    }
                }
              }
          `;

export const GET_PAGINATED_GAMES = gql`
          ${GET_GAME_FIELDS}
          query GetGamesPaginated($order:[GameSortInput!],$after: String,$before:String, $first: Int, $last: Int,$where:GameFilterInput,$category:String) {
                gamesPaginated (order:$order, first: $first,last:$last, after: $after , before: $before, where:$where,category:$category){
                 pageInfo {
                        endCursor
                        hasNextPage
                        hasPreviousPage
                        startCursor
                    }
                            
                    nodes {
                    ...GetGameFields
                    
                    }
                }
              }
          `;


export const GET_GAME_FILTERS = gql`
          query GetGameFilters {
                   gameThemes {
                         id
                         codeName
                         enabledInFilters
                         }
                   gameFeatures {
                         id
                         codeName
                         enabledInFilters
                   }
                   gameProviders {
                         id
                         name
                         logoUrl
                         logoFaviconUrl
                         urlName
                   }
                   gameStakes{
                          id
                          minStake
                          maxStake
                   }
              }
          `;

export const GET_FAVORITE_GAMES = gql`
          ${GET_GAME_FIELDS}
          query GetFavoriteGames ($order: [GameSortInput!], $where: GameFilterInput){
                favoriteGames (order: $order, where: $where){
                    ...GetGameFields
                }
              }
          `;

export const GET_RECENTLY_PLAYED_GAMES = gql`
          ${GET_GAME_FIELDS}
          query GetRecentlyPlayedGames ($order: [GameSortInput!], $after: String, $before: String, $first: Int, $last: Int, $where: GameFilterInput){
                recentlyPlayedGames (order: $order, first: $first, last: $last, after: $after, before: $before, where: $where){
                    pageInfo {
                        endCursor
                        hasNextPage
                        hasPreviousPage
                        startCursor
                    }
                    nodes {
                        ...GetGameFields
                    }
                }
              }
          `;

export const GET_RECENT_WINNINGS = gql`
          ${GET_GAME_FIELDS}
          query GetRecentWinnings ($start: DateTime, $end: DateTime, $topWins: Boolean, $first: Int, $type: RecentWinningResult){
                recentWinnings (start: $start, end: $end, topWins: $topWins, first: $first, type: $type){
                        id,
                        timestamp,
                        totalBet,
                        totalWin,
                        singleRound,
                        currency,
                        userName,
                        game {
                            ...GetGameFields
                        }
                }
              }
          `;

export const GET_GAME_CONTENT = gql`
          query GetGameContent ($gameUrlName: String!, $gameStudioUrlName: String!, $language: String!) {
                gameContent (gameUrlName: $gameUrlName, gameStudioUrlName: $gameStudioUrlName, language: $language)
              }
          `;

export const GET_GAME_PROVIDERS = gql`
          query GetGameProviders ($category: String){
                gameProviders (category: $category){
                    id
                    name
                    logoUrl
                    logoFaviconUrl
                    urlName
                }
              }
          `;